export class UserFacingError extends Error {
  titleKey = 'global.error_title'
  messageKey = 'global.error_message'

  constructor(titleKey: string, messageKey: string) {
    super()
    this.titleKey = titleKey
    this.messageKey = messageKey
  }
}

export class MfaRequiredError extends Error {}
export class FailedAuthenticationError extends Error {}
export class TooManyAttemptsError extends Error {}
